module.exports = (homeworkId) => {
  return [
    { name: 'Title', prop: 'title', type: 'text', required: true },
    { name: 'Position', prop: 'position', type: 'number' },
    {
      name: 'Required Section',
      prop: 'is_required',
      type: 'checkbox',
      helperText: 'Required sections count toward progress and homework completion'
    },
    {
      name: 'Content',
      prop: 'content',
      type: 'wysiwyg'
    }
  ]
}
